import { render, staticRenderFns } from "./BeltSelectMonthly.vue?vue&type=template&id=783d54a5&scoped=true"
import script from "./BeltSelectMonthly.vue?vue&type=script&lang=js"
export * from "./BeltSelectMonthly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783d54a5",
  null
  
)

export default component.exports